module.exports = __webpack_public_path__ + "img/ic_help_gray_24px@2x.b0b97ea2.png";